import { render } from "./ProductsSwiper.vue?vue&type=template&id=c25b5f64"
import script from "./ProductsSwiper.vue?vue&type=script&lang=js"
export * from "./ProductsSwiper.vue?vue&type=script&lang=js"

import "./ProductsSwiper.vue?vue&type=style&index=0&id=c25b5f64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__